import axios from "axios";
import i18n from "i18next";

import { MODAL_ROUTES } from "@/components/modals/router/ModalRoutes";

import globalRouter from "@/globalRouter.ts";

import { Tokens } from "./auth/auth.types";
import { removeLoginInfo } from "./tokens";

const apiUrl = import.meta.env.VITE_API_URL;
const billingApiUrl = import.meta.env.VITE_BILLING_API_URL;

export const baseAxios = axios.create({
  headers: {
    "Content-Type": "application/json",
  },
});

baseAxios.interceptors.request.use((request) => {
  const lang = localStorage.getItem("i18nextLng") || i18n.language || "ru";
  request.baseURL = `${apiUrl}/${lang}/api/v3`;
  return request;
});
export const statisticAxios = axios.create({
  ...baseAxios.defaults,
});

statisticAxios.interceptors.request.use((request) => {
  request.baseURL = `https://api.statistics.splay.uz/api/v1/`;
  return request;
});

export const authAxios = axios.create({ ...baseAxios.defaults, withCredentials: true });

export const billingAxios = axios.create({ ...baseAxios.defaults });

authAxios.interceptors.request.use((request) => {
  const lang = localStorage.getItem("i18nextLng") || i18n.language || "ru";
  request.baseURL = `${apiUrl}/${lang}/api/v3`;
  return request;
});

billingAxios.interceptors.request.use((request) => {
  const lang = localStorage.getItem("i18nextLng") || i18n.language || "ru";
  request.baseURL = `${billingApiUrl}/${lang}/api/v2`;
  return request;
});

authAxios.interceptors.request.use((request) => {
  const token = localStorage.getItem("splay:access");
  if (!request.headers.Authorization && token) {
    request.headers.Authorization = `Bearer ${token}`;
  }
  return request;
});

billingAxios.interceptors.request.use((request) => {
  const token = localStorage.getItem("splay:access");
  if (!request.headers.Authorization && token) {
    request.headers.Authorization = `Bearer ${token}`;
  }
  return request;
});

let isRefreshing = false;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
let failedQueue: any[] = [];

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const processQueue = (error: any, token: string | null = null) => {
  failedQueue.forEach((prom) => {
    if (error) {
      prom.reject(error);
    } else {
      prom.resolve(token);
    }
  });

  failedQueue = [];
};

authAxios.interceptors.response.use(
  (response) => response,
  (error) => handleRefreshToken(error),
);

billingAxios.interceptors.response.use(
  (response) => response,
  (error) => handleRefreshToken(error),
);

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const handleRefreshToken = async (error: any) => {
  const originalRequest = error.config;
  const status = error.response.status;

  if ((status === 401 || status === 403) && !originalRequest._retry) {
    if (isRefreshing) {
      return new Promise(function (resolve, reject) {
        failedQueue.push({ resolve, reject });
      })
        .then((token) => {
          originalRequest.headers.Authorization = `Bearer ${token}`;
          return authAxios(originalRequest);
        })
        .catch((err) => {
          return Promise.reject(err);
        });
    }

    originalRequest._retry = true;
    isRefreshing = true;

    const refresh = localStorage.getItem("splay:refresh");

    if (refresh) {
      try {
        const lang = localStorage.getItem("i18nextLng") || i18n.language || "ru";
        const formData = new FormData();
        formData.append("refresh", refresh);
        const res = await axios.post<Pick<Tokens, "access">>(`${apiUrl}/${lang}/api/v3/user/token/refresh`, formData);
        const { access } = res.data;
        localStorage.setItem("splay:access", access);
        // authAxios.defaults.headers.common["Authorization"] = `Bearer ${access}`;
        processQueue(null, access);
        const config = {
          ...originalRequest,
          headers: {
            ...originalRequest.headers,
            Authorization: `Bearer ${access}`,
          },
        };

        return authAxios(config);
      } catch (refreshError) {
        processQueue(refreshError, null);
        removeLoginInfo();
        if (globalRouter.navigate) {
          globalRouter.navigate(`/?modal=${MODAL_ROUTES.AUTH}/${MODAL_ROUTES.AUTH_LOGIN}`);
        }
        return Promise.reject(refreshError);
      } finally {
        isRefreshing = false;
      }
    } else {
      removeLoginInfo();
      if (globalRouter.navigate) {
        globalRouter.navigate(`/?modal=${MODAL_ROUTES.AUTH}/${MODAL_ROUTES.AUTH_LOGIN}`);
      }
    }
  }

  return Promise.reject(error);
};
